import { Route, Routes } from 'react-router';
import { Channels as ChannelsPage } from '../channel/channels';
import React from 'react';
import { ViewChannel } from '../channel/view-channel';
import { EditChannel } from '../channel/edit-channel';
import { PreviewUnits } from '../channel/preview-units';
import { BlastChannel } from '../channel/blast-channel';

export const Channels = (): JSX.Element => {
  return (
    <Routes>
      <Route path="/" element={<ChannelsPage />} />
      <Route path="/:channelId" element={<ViewChannel />} />
      <Route path="/:channelId/edit" element={<EditChannel />} />
      <Route path="/:channelId/preview" element={<PreviewUnits />} />
      <Route path="/:channelId/blast" element={<BlastChannel />} />
    </Routes>
  );
};
